import { styled } from 'goober';
import { FilterButton } from './filter-button';
import { Inline } from '@/ui/line/line';

interface TabFilterData<T> {
  label: string;
  type: T;
  resultsQuantity: number;
  isActive: boolean;
}

export const TabTableFilters = <T,>({
  filters,
  onFilterClick,
  className,
}: {
  filters: TabFilterData<T>[];
  onFilterClick: (filter: T) => void;
  className?: string;
}) => {
  return (
    <FiltersContainer className={className}>
      {filters.map(filter => (
        <FilterButton<T>
          key={filter.label}
          type={filter.type}
          label={filter.label}
          quantity={filter.resultsQuantity}
          isActive={filter.isActive}
          onClick={onFilterClick}
        />
      ))}
    </FiltersContainer>
  );
};

const FiltersContainer = styled(Inline)`
  padding: 5px;
`;
